module.exports = __webpack_public_path__ + "img/image5.b2a39c93.png";